import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotAllowedComponent } from './pages/not-allowed/not-allowed.component';
import { SiteErrorComponent } from './pages/site-error/site-error.component';

const routes: Routes = [
  {
    path: 'error',
    component: SiteErrorComponent,
  },
  {
    path: 'not-registered',
    component: NotAllowedComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SharedRoutingModule {}
